import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import baseURL from '../utils/baseURL';
import useAxiosAuth from '../hooks/useAxiosAuth';

// Create a new rule
export const createRule = createAsyncThunk(
    'rules/createRule',
    async (payload, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.post(`${baseURL}/doctor-calendar`, payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Get single rule
export const getSingleRule = createAsyncThunk(
    'rules/getSingleRule',
    async (params, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(`${baseURL}/doctor-calendar/single`, { params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Get all rules
export const getAllRules = createAsyncThunk(
    'rules/getAllRules',
    async (params, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.get(`${baseURL}/doctor-calendar/`, { params });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Delete rule
export const deleteRule = createAsyncThunk(
    'rules/deleteRule',
    async (ruleId, { rejectWithValue }) => {
        const axiosInstance = useAxiosAuth();
        try {
            const response = await axiosInstance.delete(`${baseURL}/doctor-calendar/`, {
                params: { ruleId }
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

const rulesSlice = createSlice({
    name: 'rules',
    initialState: {
        rules: [],
        selectedRule: null,
        loading: false,
        error: null,
    },
    reducers: {
        clearRulesError: (state) => {
            state.error = null;
        },
        clearSelectedRule: (state) => {
            state.selectedRule = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // Create Rule
            .addCase(createRule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createRule.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(createRule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Get Single Rule
            .addCase(getSingleRule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSingleRule.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedRule = action.payload;
            })
            .addCase(getSingleRule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Get All Rules
            .addCase(getAllRules.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllRules.fulfilled, (state, action) => {
                state.loading = false;
                state.rules = action.payload;
            })
            .addCase(getAllRules.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            // Delete Rule
            .addCase(deleteRule.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteRule.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(deleteRule.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearRulesError, clearSelectedRule } = rulesSlice.actions;
export default rulesSlice.reducer;
